import { createFileRoute } from "@tanstack/react-router";
import { Footer } from "@/components/Footer";
import { Header } from "@/components/Header";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Conditions Générales de Vente — angle-shop.com" },
      { name: "description", content: "Conditions générales de vente de angle-shop.com. Réglementation e-commerce et informations légales." },
    ],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="prose prose-slate max-w-none">
          <h1 className="text-3xl font-bold text-foreground mb-8">Terms & Conditions</h1>
          
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-foreground mb-4">Preamble</h2>
            <p className="text-muted-foreground leading-relaxed">
              These Terms and Conditions govern the contractual relationship between angle-shop.com 
              and any customer making a purchase on the website www.autoconnect.com. By placing an order, 
              the customer accepts these conditions without reservation.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-foreground mb-4">Article 1 — Scope</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
              These Terms apply to all product sales made on angle-shop.com, 
              intended for customers residing in the United States and internationally.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              Any order implies full and unconditional acceptance of these conditions. 
              angle-shop.com reserves the right to modify these conditions at any time. 
              The applicable conditions are those in force at the date of the order.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-foreground mb-4">Article 2 — Product Characteristics</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
              angle-shop.com sells smart connected car accessories: CarPlay screens, dashcams, backup cameras, 
              HUD displays, wireless chargers, and FM transmitters.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-3">
              Product photographs and descriptions are provided for informational purposes. 
              angle-shop.com strives to accurately represent products but does not guarantee 
              a perfect color match on screen.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              <strong>Operating model — Dropshipping:</strong> Products are shipped directly 
              by our partner suppliers. This allows us to offer competitive prices while 
              ensuring the quality of selected items.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-foreground mb-4">Article 3 — Prices and Payment</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
              Prices are listed in US dollars and include all applicable taxes. 
              Shipping costs are indicated before order validation.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-3">
              <strong>Free shipping:</strong> Shipping is free for all orders over 59€. 
              For orders below this amount, a shipping fee of 4,90€ applies.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-3">
              angle-shop.com reserves the right to modify its prices at any time, but products will be 
              billed based on the rates in effect at the time of order registration.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              Payment is made online by credit card through our secure payment partner Stripe. 
              The transaction is encrypted and secure (SSL). angle-shop.com never has access to the customer's banking data.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-foreground mb-4">Article 4 — Orders</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
              The customer selects the desired products and adds them to their cart. Before validation, 
              they can review the order details and correct any errors.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-3">
              The order is validated when the customer clicks the "Pay" button after accepting 
              these Terms. A confirmation email is sent to the customer summarizing the order 
              and its reference number.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              angle-shop.com reserves the right to cancel or refuse any order in case of dispute 
              with the customer, proven insolvency, or suspected fraud.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-foreground mb-4">Article 5 — Delivery</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
              Products are shipped to the address indicated by the customer during the order. 
              Estimated delivery times are:
            </p>
            <ul className="list-disc pl-5 text-muted-foreground mb-3 space-y-1">
              <li>United States: 5 to 10 business days</li>
              <li>International: 7 to 15 business days</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mb-3">
              These times are approximate and may vary depending on the product ordered and the destination. 
              angle-shop.com cannot be held responsible for delays attributable to carriers.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              <strong>30-day guarantee:</strong> If your order is not delivered within 30 days, 
              you are entitled to a full refund, no questions asked.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-foreground mb-4">Article 6 — Returns & Refunds</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
              The customer has 30 days from receipt to return a product, 
              without having to justify reasons or pay penalties.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-3">
              To exercise this right, the customer must inform us of their decision by email at 
              nessimselmane49@gmail.com or through the contact form on the website. 
              Products must be returned in their original condition, complete and unused, 
              within 14 days of communicating the return decision.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              Return shipping costs are the responsibility of the customer, except in case of a defective or non-conforming product. 
              The refund is made within a maximum of 14 days after receiving the returned products, 
              using the same payment method used for the original order.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-foreground mb-4">Article 7 — Warranties</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
              <strong>Conformity warranty:</strong> angle-shop.com guarantees the conformity of products to the sales contracts. 
              In case of non-conformity noted upon receipt or appearing within 2 years of delivery, 
              the customer may request repair or replacement of the product, or failing that, a price reduction 
              or contract termination.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              <strong>Manufacturer warranty:</strong> Products benefit from a manufacturer warranty 
              of 1 to 2 years depending on the item. Details are indicated on each product page.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-foreground mb-4">Article 8 — Liability</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
              angle-shop.com disclaims any liability in case of misuse of the products sold. 
              The customer is responsible for the correct installation of automotive accessories and their 
              use in accordance with the instructions provided.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              angle-shop.com's liability cannot be engaged for indirect damages, 
              loss of business or loss of profit resulting from the use of the products.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-foreground mb-4">Article 9 — Intellectual Property</h2>
            <p className="text-muted-foreground leading-relaxed">
              All elements of the angle-shop.com website (texts, images, logos, photographs, videos, 
              graphics) are protected by copyright and trademark law. 
              Any reproduction, exploitation or use, total or partial, is strictly prohibited 
              without prior written authorization.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-foreground mb-4">Article 10 — Personal Data</h2>
            <p className="text-muted-foreground leading-relaxed">
              Personal data collected during the order is processed in accordance 
              with our Privacy Policy. The customer has the right to access, rectify and delete their data 
              by contacting us at nessimselmane49@gmail.com.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-4">Article 11 — Legal Information</h2>
            <div className="bg-muted p-6 rounded-lg">
              <p className="text-muted-foreground leading-relaxed mb-2">
                <strong>angle-shop.com</strong><br />
                Email: nessimselmane49@gmail.com
              </p>
              <p className="text-muted-foreground leading-relaxed text-sm mt-4">
                Last updated: April 15, 2026
              </p>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
